export default "__VITE_ASSET__8766a45a__"